module.exports = "/_next/static/images/Personalization-sm@2x-9d19b512736046831de7ec6ac2e43913.png";